import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { FronteiraDeErro } from "@/components/FronteiraDeErro";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FronteiraDeErro>
      <App />
    </FronteiraDeErro>
  </React.StrictMode>,
);
